import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  declineReason: '',
  onlineUsers: [],
  searchedUsers: {},
  extraUsers: {},
  favoriteUsers: {},
  selectedUser: {},
  blockedUsers: {},
  searchErrorResult: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js